(() => {
  const init = () => {
    const modal = document.querySelector('[data-lux-review-modal]');
    const openers = document.querySelectorAll('[data-lux-review-modal-open]');
    if (!modal || !openers.length) return;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const panel = modal.querySelector('[data-lux-review-modal-panel]');
    const iframe = modal.querySelector('[data-lux-review-modal-frame]');
    const closers = modal.querySelectorAll('[data-lux-review-modal-close]');
    let lastFocus = null;

    const lockScroll = () => {
      document.documentElement.classList.add('lux-review-modal-lock');
      document.body.classList.add('lux-review-modal-lock');
    };

    const unlockScroll = () => {
      document.documentElement.classList.remove('lux-review-modal-lock');
      document.body.classList.remove('lux-review-modal-lock');
    };

    const loadIframe = async () => {
      if (!iframe) return;
      const source = iframe.getAttribute('data-src');
      if (!source || iframe.dataset.loaded === 'true' || iframe.dataset.loading === 'true') return;

      iframe.dataset.loading = 'true';
      iframe.setAttribute('srcdoc', `<!doctype html><html><head><base href="${window.location.origin}/"><meta name="viewport" content="width=device-width, initial-scale=1"><style>html,body{height:100%;margin:0;background:#f4f4f1;font-family:Inter,Arial,sans-serif;color:#111827}.lux-modal-loading{height:100%;display:grid;place-items:center;text-align:center;padding:24px;box-sizing:border-box}.lux-modal-loading__card{background:#fff;border:1px solid rgba(17,24,39,.10);border-radius:14px;padding:22px 24px;box-shadow:0 8px 24px rgba(17,24,39,.08)}.lux-modal-loading__spinner{width:28px;height:28px;border:3px solid #d1fae5;border-top-color:#00b67a;border-radius:50%;margin:0 auto 12px;animation:luxSpin .8s linear infinite}@keyframes luxSpin{to{transform:rotate(360deg)}}p{margin:0;font-size:14px;font-weight:700}</style></head><body><div class="lux-modal-loading"><div class="lux-modal-loading__card"><div class="lux-modal-loading__spinner" aria-hidden="true"></div><p>Loading Luxazora reviews…</p></div></div></body></html>`);
      try {
        const response = await fetch(source, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Reviews page returned ${response.status}`);
        let html = await response.text();
        const baseTag = `<base href="${window.location.origin}/">`;
        if (/<head[\s>]/i.test(html) && !/<base[\s>]/i.test(html)) {
          html = html.replace(/<head([^>]*)>/i, `<head$1>${baseTag}`);
        }
        iframe.setAttribute('srcdoc', html);
        iframe.dataset.loaded = 'true';
      } catch (error) {
        console.warn('Luxazora reviews modal iframe fetch failed.', error);
        iframe.setAttribute('srcdoc', `<!doctype html><html><head><base href="${window.location.origin}/"><meta name="viewport" content="width=device-width, initial-scale=1"><style>html,body{height:100%;margin:0;background:#f4f4f1;font-family:Inter,Arial,sans-serif;color:#111827}.lux-modal-error{height:100%;display:grid;place-items:center;text-align:center;padding:24px;box-sizing:border-box}.lux-modal-error__card{max-width:420px;background:#fff;border:1px solid rgba(17,24,39,.12);border-radius:14px;padding:22px 24px;box-shadow:0 8px 24px rgba(17,24,39,.08)}h3{margin:0 0 8px;font-size:18px}p{margin:0 0 16px;font-size:14px;line-height:1.45;color:#4b5563}a{display:inline-flex;align-items:center;justify-content:center;padding:12px 16px;border-radius:999px;background:#00b67a;color:#fff;text-decoration:none;font-weight:800;font-size:14px}</style></head><body><div class="lux-modal-error"><div class="lux-modal-error__card"><h3>Reviews are taking longer to load</h3><p>You can still open the full Luxazora reviews page.</p><a href="${source}" target="_blank" rel="noopener">Open reviews</a></div></div></body></html>`);
      } finally {
        iframe.dataset.loading = 'false';
      }
    };

    const openModal = (event) => {
      if (event) event.preventDefault();
      lastFocus = document.activeElement;
      loadIframe();
      modal.classList.add('is-open');
      modal.removeAttribute('aria-hidden');
      lockScroll();
      window.setTimeout(() => {
        if (panel) panel.focus({ preventScroll: true });
      }, 30);
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus({ preventScroll: true });
      }
    };

    openers.forEach((opener) => opener.addEventListener('click', openModal));
    closers.forEach((closer) => closer.addEventListener('click', closeModal));

    const params = new URLSearchParams(window.location.search);
    if (params.get('lux_review_modal') === '1' || window.location.hash === '#lux-review-modal') {
      window.setTimeout(() => openModal(), 450);
    }

    document.addEventListener('keydown', (event) => {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab' || !panel) return;

      const focusable = panel.querySelectorAll('a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
